// extracted by mini-css-extract-plugin
module.exports = {"signInLink":"forgot-password_signInLink__xbTjW"};